module.exports = __webpack_public_path__ + "static/media/Products 2.e87c7d90.svg";